// extracted by mini-css-extract-plugin
export var sizeL = "Wrapper-module--sizeL--968d6";
export var sizeM = "Wrapper-module--sizeM--61ba7";
export var sizeML = "Wrapper-module--sizeML--b3490";
export var sizeMS = "Wrapper-module--sizeMS--bd431";
export var sizeS = "Wrapper-module--sizeS--ade48";
export var sizeSL = "Wrapper-module--sizeSL--48d0f";
export var sizeXl = "Wrapper-module--sizeXl--28a58";